import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putProduct } from '../Api'

export default generateApiAction({
  baseType: Types.PRODUCTS.PUT.FULL,
  api: putProduct,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/products/PutFullAction.js